'use client'

import { useTranslations } from 'next-intl'
import { cx } from 'class-variance-authority'
import { currencies } from '@skop-app/lib-domain/constants'
import { getOrderAggregateCurrency } from '@/features/quote/lib/orderCurrency'

import { OrderModalValues } from '@/types'
import { numberFormatter } from '@/utils'

export const OrderPriceIndicator = ({
  orderValues,
  hideTotal,
  isOrder = orderValues.type !== 'FAVORITE',
}: {
  orderValues: OrderModalValues
  hideTotal?: boolean
  isOrder?: boolean
}) => {
  const t = useTranslations()

  const { subTotal, vat, total } = orderValues
  const aggregateCurrency = getOrderAggregateCurrency(orderValues, isOrder)
  const currencySign = isOrder
    ? orderValues.currency?.sign
    : (currencies.find(
        (currency) =>
          String(currency.value).toUpperCase() ===
          aggregateCurrency?.toUpperCase(),
      )?.sign ?? aggregateCurrency)

  return (
    <div
      className={cx(
        'flex flex-col justify-between gap-1 rounded bg-zinc-100 p-2 text-sm',
        hideTotal && 'hidden',
      )}
    >
      <p className="flex items-center justify-between">
        <span>{t('Documents-directory.tax.subtotal')}</span>
        <span>
          {subTotal == null
            ? '-'
            : numberFormatter({
                value: subTotal,
                currencySign,
                commaSeparator: true,
              })}
        </span>
      </p>
      <p className="flex items-center justify-between">
        <span>
          {t('Documents-directory.tax.vat', {
            value: orderValues?.vatPercentage?.value ?? 0,
          })}
        </span>
        <span>
          {vat == null
            ? '-'
            : numberFormatter({
                value: vat,
                currencySign,
                commaSeparator: true,
              })}
        </span>
      </p>
      <p className="flex items-center justify-between font-semibold">
        <span>{t('Documents-directory.tax.total')}</span>
        <span>
          {total == null
            ? '-'
            : numberFormatter({
                value: total,
                currencySign,
                commaSeparator: true,
              })}
        </span>
      </p>
    </div>
  )
}
